import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';

export const orderConfig: DeepPartial<OrderConfig> = {
  premium: {
    enabled: false,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
};
